import React from 'react';
import { FormGrid, SimpleDialog } from '../../toolympus/components/primitives';
import { Schema } from '../../toolympus/hooks/useSchema';
import { FormControlsForFields } from '../../toolympus/components/schemed';
import { NewItemProps } from '../../toolympus/api/useNewItem';
import { ExpertComment, NewExpertComment } from './useExpertCommentsList';

interface Props extends NewItemProps<NewExpertComment, ExpertComment> {
  schema: Schema;
}

export const CreateExpertCommentDialog = (props: Props) => {
  const { isEditing, cancel, errors, item, update, save, schema } = props;
  return (
    <SimpleDialog
      isOpen={isEditing}
      close={cancel}
      dialogTitle="Новое экспертное мнение"
      save={() => save()}>
      {item && <FormGrid columns="1fr">
        <FormControlsForFields
          fields={[
            ["title"],
            ["comment_date"],
          ]}
          data={item}
          onChange={(o,c) => update(c)}
          errors={errors}
          schema={schema}
          />
      </FormGrid>}
    </SimpleDialog>
  );
}
